import axios from "axios"

export default {
  accessTableLoad({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/rbac/dealer-access-config`).then(res => {
        resolve(res.data);
        commit('updateAccessTable', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  deleteRole({dispatch}, body) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/rbac/roles/${body.id}/delete`, {
        'new_role_id': body.new_role,
      }).then(res => {
        resolve(res.data);
        dispatch('accessTableLoad');
        dispatch('rolesEmployeesLoad');
      }, error => {
        reject(error)
      })
    })
  },

  setAccessCell({commit}, body) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/rbac/roles/${body.roleId}/permissions/${body.permissionId}/update-level `, {
        'access_level': body.level,
      }).then(res => {
        resolve(res);
        commit('updateAccessCell', {
          'index': body.index,
          'permissionsIndex': body.permissionsIndex,
          'levelIndex': body.levelIndex,
          'level': body.level,
        })
      }, error => {
        reject(error)
      })
    })
  },

  rolesLoad({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/rbac/roles`).then(res => {
        resolve(res.data);
        commit('updateRoles', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  rolesAdd({dispatch}, body) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/rbac/roles `, body).then(res => {
        resolve(res);
        dispatch('accessTableLoad');
        dispatch('rolesEmployeesLoad');
        dispatch('rolesLoad');
      }, error => {
        reject(error)
      })
    })
  },

  rolesEmployeesLoad({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/rbac/employees-by-roles`).then(res => {
        resolve(res.data);
        commit('updateRolesEmployees', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  rolesChange({dispatch}, body) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/rbac/roles/assign `, body).then(res => {
        resolve(res);
        dispatch('rolesEmployeesLoad');
        dispatch('accessTableLoad');
      }, error => {
        reject(error)
      })
    })
  },
}
